
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 640"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M199.2 181.4L173.1 256h293.8l-26.1-74.6c-4.5-12.8-16.6-21.4-30.2-21.4H229.4c-13.6 0-25.7 8.6-30.2 21.4zm-95.6 79.4l35.2-100.5c13.5-38.5 49.8-64.3 90.6-64.3h181.2c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32H160v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V320c0-26.7 16.4-49.6 39.6-59.2zM192 368c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm288 32c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"}})])
          )
        }
      }
    